/**
 * PWZ custom homepage interactions.
 * Scoped to .pwz-homepage — review rotator, sticky CTA, add-to-cart toast.
 * Uses event delegation so Theme Editor section reloads keep working.
 */
(function () {
  if (window.__pwzHomepageInit) return;
  window.__pwzHomepageInit = true;

  function markMain() {
    var main = document.getElementById("MainContent");
    if (main) {
      main.classList.remove("overflow-x-clip", "overflow-y-clip");
      main.classList.add("pwz-homepage-main");
    }
  }

  function showToast(message) {
    var toast = document.querySelector("[data-pwz-toast]");
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("show");
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(function () {
      toast.classList.remove("show");
    }, 1600);
  }

  function dispatchCartUpdate(cart) {
    document.dispatchEvent(
      new CustomEvent("cart:update", {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: "pwz-homepage",
          data: {
            itemCount: cart && typeof cart.item_count === "number" ? cart.item_count : 0,
            isIncremental: false,
            source: "pwz-homepage",
          },
        },
      })
    );
    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: { cart: cart },
      })
    );
    document.dispatchEvent(
      new CustomEvent("product-ajax:added", {
        bubbles: true,
        detail: { product: cart },
      })
    );
  }

  function addToCart(variantId, productName, button) {
    var name = productName || "Item";
    if (!variantId) {
      showToast(name + " added to cart");
      return;
    }

    if (button) button.setAttribute("aria-busy", "true");

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showToast(result.data && (result.data.description || result.data.message) ? result.data.description || result.data.message : "Could not add to cart");
          return;
        }
        showToast(name + " added to cart");
        return fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) {
            return r.json();
          })
          .then(dispatchCartUpdate);
      })
      .catch(function () {
        showToast("Could not add to cart");
      })
      .finally(function () {
        if (button) button.removeAttribute("aria-busy");
      });
  }

  function ugcTrack(from) {
    var wrap = from && from.closest ? from.closest(".ugc-reels-wrap") : null;
    return wrap ? wrap.querySelector("[data-pwz-ugc-track]") : null;
  }

  function updateUgcArrows(track) {
    if (!track) return;
    var wrap = track.closest(".ugc-reels-wrap");
    if (!wrap) return;
    var prev = wrap.querySelector("[data-pwz-ugc-prev]");
    var next = wrap.querySelector("[data-pwz-ugc-next]");
    var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function scrollUgc(track, direction) {
    if (!track) return;
    var card = track.querySelector(".ugc-reel");
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 12;
    var amount = card ? card.getBoundingClientRect().width + gap : Math.max(track.clientWidth / 4, 240);
    track.scrollBy({ left: direction * amount, behavior: "smooth" });
  }

  function bindUgcTracks() {
    document.querySelectorAll("[data-pwz-ugc-track]").forEach(updateUgcArrows);
  }

  function ugcRoot(from) {
    return from && from.closest ? from.closest("[data-pwz-ugc-root], .ugc-reels-wrap") : null;
  }

  function stopUgcPlayers(scope, exceptCard) {
    if (!scope) return;
    scope.querySelectorAll(".ugc-reel.is-playing").forEach(function (card) {
      if (card === exceptCard) return;
      card.classList.remove("is-playing");
      var video = card.querySelector(".ugc-reel-native");
      if (video) {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (error) {}
      }
      var iframe = card.querySelector(".ugc-reel-embed");
      if (iframe) iframe.remove();
      var play = card.querySelector("[data-pwz-ugc-play]");
      if (play) {
        play.hidden = false;
        play.removeAttribute("aria-hidden");
      }
    });
  }

  function coverUgcEmbed(iframe, card) {
    if (!iframe || !card) return;
    var media = card.querySelector("[data-pwz-ugc-media]");
    var rect = (media || card).getBoundingClientRect();
    var cardW = rect.width;
    var cardH = rect.height;
    if (!cardW || !cardH) return;

    var isShorts = card.classList.contains("is-shorts");
    var ratioW = isShorts ? 9 : 16;
    var ratioH = isShorts ? 16 : 9;
    var videoRatio = ratioW / ratioH;
    var iframeW;
    var iframeH;

    if (cardW / cardH > videoRatio) {
      iframeW = cardW;
      iframeH = cardW / videoRatio;
    } else {
      iframeH = cardH;
      iframeW = cardH * videoRatio;
    }

    var scale = isShorts ? 1.28 : 1.18;
    iframeW = Math.ceil(iframeW * scale);
    iframeH = Math.ceil(iframeH * scale);

    iframe.setAttribute("width", String(iframeW));
    iframe.setAttribute("height", String(iframeH));
    iframe.style.width = iframeW + "px";
    iframe.style.height = iframeH + "px";
    iframe.style.top = "50%";
    iframe.style.left = "50%";
    iframe.style.right = "auto";
    iframe.style.bottom = "auto";
    iframe.style.transform = "translate(-50%, -50%)";
  }

  function resizePlayingUgcEmbeds() {
    document.querySelectorAll(".ugc-reel.is-playing .ugc-reel-embed").forEach(function (iframe) {
      coverUgcEmbed(iframe, iframe.closest(".ugc-reel"));
    });
  }

  function playUgcCard(button) {
    var card = button.closest(".ugc-reel");
    var media = card && card.querySelector("[data-pwz-ugc-media]");
    if (!card || !media || card.classList.contains("is-playing")) return;

    stopUgcPlayers(ugcRoot(card), card);

    var type = button.getAttribute("data-video-type");
    if (type === "shopify") {
      var video = media.querySelector(".ugc-reel-native");
      if (!video) return;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.playsInline = true;
      card.classList.add("is-playing");
      button.hidden = true;
      button.setAttribute("aria-hidden", "true");
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
      if (card.scrollIntoView) {
        card.scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
      }
      return;
    }

    var embedUrl = button.getAttribute("data-embed-url");
    if (!embedUrl) return;

    var iframe = document.createElement("iframe");
    iframe.className = "ugc-reel-embed";
    iframe.src = embedUrl;
    iframe.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture");
    iframe.setAttribute("allowfullscreen", "true");
    iframe.setAttribute("loading", "lazy");
    iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
    iframe.setAttribute("title", button.getAttribute("data-iframe-title") || "Video");
    iframe.setAttribute("playsinline", "");
    media.appendChild(iframe);
    coverUgcEmbed(iframe, card);
    card.classList.add("is-playing");
    button.hidden = true;
    button.setAttribute("aria-hidden", "true");

    if (card.scrollIntoView) {
      card.scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
    }
  }

  function updateStickies() {
    var show = window.scrollY > 1200 && window.innerWidth > 700;
    document.querySelectorAll("[data-pwz-sticky]").forEach(function (sticky) {
      sticky.classList.toggle("show", show);
    });
  }

  document.addEventListener("click", function (event) {
    var ugcPlay = event.target.closest("[data-pwz-ugc-play]");
    if (ugcPlay) {
      event.preventDefault();
      event.stopPropagation();
      playUgcCard(ugcPlay);
      return;
    }

    var ugcNav = event.target.closest("[data-pwz-ugc-prev], [data-pwz-ugc-next]");
    if (ugcNav) {
      event.preventDefault();
      scrollUgc(ugcTrack(ugcNav), ugcNav.hasAttribute("data-pwz-ugc-next") ? 1 : -1);
      return;
    }

    var reviewButton = event.target.closest("[data-pwz-reviews] [data-pwz-review-dot]");
    if (reviewButton) {
      var root = reviewButton.closest("[data-pwz-reviews]");
      if (!root) return;
      root.querySelectorAll("[data-pwz-review-dot]").forEach(function (item) {
        item.classList.remove("active");
      });
      reviewButton.classList.add("active");
      var quote = root.querySelector("[data-pwz-quote]");
      var meta = root.querySelector("[data-pwz-review-meta]");
      if (quote && reviewButton.getAttribute("data-quote")) {
        quote.textContent = reviewButton.getAttribute("data-quote");
      }
      if (meta) {
        meta.textContent = reviewButton.getAttribute("data-meta") || "";
      }
      return;
    }

    var button = event.target.closest(".pwz-homepage .add-btn");
    if (button) {
      if (button.closest("quick-add-component")) return;
      event.preventDefault();
      addToCart(button.getAttribute("data-variant-id"), button.getAttribute("data-product"), button);
      return;
    }

    if (event.target.closest("a, button, input, select, textarea, quick-add-component, .product-actions")) return;

    var card = event.target.closest(".pwz-homepage .product-card[data-pwz-product-url]");
    if (!card) return;
    if (window.getSelection && String(window.getSelection())) return;

    var url = card.getAttribute("data-pwz-product-url");
    if (!url) return;
    event.preventDefault();
    window.location.assign(url);
  });

  document.addEventListener(
    "scroll",
    function (event) {
      if (event.target && event.target.getAttribute && event.target.hasAttribute("data-pwz-ugc-track")) {
        updateUgcArrows(event.target);
      }
    },
    true
  );

  window.addEventListener("scroll", updateStickies, { passive: true });
  window.addEventListener("resize", function () {
    updateStickies();
    bindUgcTracks();
    resizePlayingUgcEmbeds();
  });

  markMain();
  updateStickies();
  bindUgcTracks();

  document.addEventListener(
    "error",
    function (event) {
      var img = event.target;
      if (!img || img.tagName !== "IMG") return;
      var fallback = img.getAttribute("data-yt-fallback");
      if (!fallback || img.src === fallback) return;
      img.src = fallback;
      img.removeAttribute("data-yt-fallback");
      var card = img.closest(".ugc-reel");
      if (card && !card.classList.contains("is-shorts-poster-crop")) {
        card.style.setProperty("--ugc-reel-art", "url('" + fallback + "')");
        card.style.setProperty("--ugc-poster", "url('" + fallback + "')");
        card.style.backgroundImage = "url('" + fallback + "')";
        card.style.backgroundSize = "cover";
        card.style.backgroundPosition = "center";
      }
    },
    true
  );

  document.addEventListener("shopify:section:load", function () {
    markMain();
    updateStickies();
    bindUgcTracks();
  });
  document.addEventListener("shopify:section:unload", function (event) {
    stopUgcPlayers(event.target);
  });
  document.addEventListener("shopify:section:reorder", updateStickies);
})();
